
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireecd3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireecd3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $28d01fb0461f82d7$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["hCUUh","free-samples.8ddca78e.js","1jI57","sushi.89bb5e9c.png"]'));

var $d281e5296e6f42ef$exports = {};
$d281e5296e6f42ef$exports = new URL("sushi.89bb5e9c.png", import.meta.url).toString();


document.addEventListener("DOMContentLoaded", ()=>{
    const plate = document.getElementById("plate");
    const controls = document.getElementById("controls");
    const respawnButton = document.getElementById("respawnButton");
    const sushiCountSlider = document.getElementById("sushiCountSlider");
    const sushiCountDisplay = document.getElementById("sushiCountDisplay");
    let sushiCount = parseInt(sushiCountSlider.value, 10);
    sushiCountSlider.addEventListener("input", function() {
        sushiCount = parseInt(this.value, 10);
        sushiCountDisplay.textContent = sushiCount;
    });
    function getRandomPosition() {
        const x = Math.random() * 60;
        const y = Math.random() * 60;
        return {
            x: x,
            y: y
        };
    }
    function getRandomColor() {
        const letters = "0123456789ABCDEF";
        let color = "#";
        for(let i = 0; i < 6; i++)color += letters[Math.floor(Math.random() * 16)];
        return color;
    }
    function addSushi() {
        for(let i = 0; i < sushiCount; i++){
            const sushi = document.createElement("img");
            sushi.src = (0, (/*@__PURE__*/$parcel$interopDefault($d281e5296e6f42ef$exports))); // Ensure this path is correct
            // sushi.src = "/imgs/sushi.png";
            sushi.alt = "Sushi";
            sushi.className = "sushi";
            const { x: x, y: y } = getRandomPosition();
            sushi.style.left = `${x + 10}%`;
            sushi.style.top = `${y + 10}%`;
            sushi.addEventListener("click", function() {
                sushi.remove();
                checkPlateEmpty();
            });
            plate.appendChild(sushi);
        }
        checkPlateEmpty();
    }
    function respawnSushi() {
        plate.innerHTML = "";
        plate.style.backgroundColor = getRandomColor();
        addSushi();
    }
    function checkPlateEmpty() {
        const sushiElements = plate.querySelectorAll(".sushi");
        if (sushiElements.length === 0) controls.style.display = "flex";
        else controls.style.display = "none";
    }
    respawnButton.addEventListener("click", respawnSushi);
    addSushi();
});


//# sourceMappingURL=free-samples.8ddca78e.js.map
